import { __decorate } from "tslib";
import { css, html } from 'lit';
import { Router } from '@vaadin/router';
import { customElement, property, state } from 'lit/decorators.js';
import { router } from './router.js';
import '../components/svgIcons.js';
import { parseJwt } from './helpers.js';
import { subscribe } from './reactiveX/rxElementDecorators.js';
import { RxElement } from './reactiveX/rxElement.js';
import { GlobalRxStores } from './reactiveX/globalRxStores.js';
const globalUsers = ['merili.forrest@financialfinesse.com'];
const devs = [
    'oscar.munoz@financialfinesse.com',
    'dusten.salinas@financialfinesse.com',
    'raf.hernandez@financialfinesse.com',
    'justin.harkey@financialfinesse.com',
    'merili.forrest@financialfinesse.com',
    'statia.thomas@financialfinesse.com',
    'alejandro.pick@financialfinesse.com',
    'oleg.baranovsky@financialfinesse.com',
    'fitz.villafuerte@financialfinesse.com',
    'doug.spencer@financialfinesse.com',
];
const sidebarRoutes = [
    { route: '/dashboard', name: 'Dashboard', icon: 'home' },
    { route: '/fulfillments', name: 'Fulfillments', icon: 'email' },
    { route: '/users', name: 'Users', icon: 'account-multiple-outline' },
    { route: '/hubs', name: 'Benefits Editor', icon: 'hub' },
];
let MainSidebar = class MainSidebar extends RxElement {
    constructor() {
        super(...arguments);
        this.currentPath = '';
        this.isCollapsed = true;
        this.hasUserToggled = false;
        this.parsedToken = {};
        this.coachEmail = '';
        this._onRouteChange = () => {
            this.currentPath = router.location.getUrl();
        };
        this._onNavClick = (e, to) => {
            e.preventDefault();
            Router.go(to);
        };
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.parsedToken = parseJwt(this.blueUser.accessToken ? this.blueUser.accessToken : '');
        this.coachEmail = this.parsedToken.upn;
        this.currentPath = router.location.getUrl();
        const store = GlobalRxStores.getDefaultStore();
        this.authGrants = ((_a = store.behaviorSubjectsByKey.get('authGrants')) === null || _a === void 0 ? void 0 : _a.getValue()) || null;
        window.addEventListener('vaadin-router-location-changed', this._onRouteChange);
    }
    disconnectedCallback() {
        window.removeEventListener('vaadin-router-location-changed', this._onRouteChange);
        super.disconnectedCallback();
    }
    // eslint-disable-next-line class-methods-use-this
    getGrantsCmsRoutes() {
        var _a;
        if (!((_a = this.authGrants) === null || _a === void 0 ? void 0 : _a.cms))
            return [];
        return [{ route: '/cms/articles', name: 'RafPress', icon: 'library' }];
    }
    getSidebarRoutes() {
        const lowerCasedCoachEmail = (this.coachEmail || '').toLowerCase();
        const segments = (this.currentPath || '').split('/').filter(Boolean);
        const hubSlug = segments.length > 0 ? segments[0] : '';
        const staticTop = new Set([
            'dashboard',
            'fulfillments',
            'users',
            'cms',
            'hubs',
            'financial-portrait',
            'life-events',
            'library',
            'knowledge',
            'upcoming-sessions',
            'case',
        ]);
        const hasValidHubSlug = hubSlug !== '' && !staticTop.has(hubSlug);
        const destination = hasValidHubSlug ? `/${hubSlug}` : '/global';
        const dynamicGlobalRoute = {
            route: destination,
            name: 'Global-Dashboard',
            icon: 'globe',
        };
        const cmsRoutes = this.getGrantsCmsRoutes();
        const routes = [...sidebarRoutes, ...cmsRoutes];
        if (devs.some(u => u === lowerCasedCoachEmail)) {
            return [dynamicGlobalRoute, ...routes];
        }
        if (globalUsers.some(u => u === lowerCasedCoachEmail)) {
            return [dynamicGlobalRoute];
        }
        return routes;
    }
    isCurrentLocation(route) {
        const routerPath = router.urlForPath(route);
        const currentPathOnly = (this.currentPath || '').split('?')[0];
        if (routerPath === '/dashboard' && currentPathOnly === '/') {
            return true;
        }
        return routerPath === currentPathOnly;
    }
    _toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
    }
    static get styles() {
        return css `
			:host {
				min-height: 100%;
				background-color: #fff;
				width: 226px;
				transition: width 0.3s ease;
				display: block;
				overflow: hidden;
				contain: layout style;
				will-change: width;
			}
			:host([iscollapsed]) {
				width: 50px;
			}
			.sidebar {
				height: 100%;
				overflow: hidden;
			}
			.sidebar__header {
				display: flex;
				align-items: center;
				height: 88px;
				padding: 0 18px;
				position: relative;
			}
			:host([iscollapsed]) .sidebar__header {
				justify-content: center;
			}
			.sidebar__header-button {
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: inherit;
				border: none;
				cursor: pointer;
				height: 33px;
				left: 18.5px;
				padding: 0;
				position: absolute;
				top: 27.5px;
				width: 33px;
			}
			:host([iscollapsed]) .sidebar__header-button {
				position: static;
				margin: 0 auto;
			}
			.sidebar__header-icon {
				height: 22px;
				width: 22px;
			}
			.sidebar__header-logo-link {
				display: flex;
				align-items: center;
				flex: 1 1;
				justify-content: flex-start;
				margin-left: 35px;
				opacity: 1;
				visibility: visible;
				transition: opacity 0.2s ease 0.1s, visibility 0.2s ease 0.1s;
			}
			:host([iscollapsed]) .sidebar__header-logo-link {
				opacity: 0;
				visibility: hidden;
				width: 0;
				margin: 0;
				transition: opacity 0.15s ease, visibility 0.15s ease;
			}
			.sidebar__header-logo {
				max-height: 30px;
				max-width: 150px;
			}
			.sidebar__menu-item {
				display: flex;
				align-items: center;
				text-decoration: none;
				color: #707070;
				font-size: 14px;
				font-weight: 400;
				padding: 14px 20px 14px 16px;
				border-left: 4px solid transparent;
				white-space: nowrap;
			}
			.sidebar__menu-item-label {
				margin-left: 12px;
				opacity: 1;
				visibility: visible;
				transition: opacity 0.2s ease 0.1s;
			}
			.sidebar__menu-item:hover {
				background-color: #f7f7fa;
			}
			.sidebar__menu-item--active {
				font-weight: 700;
				color: #077cab;
				border-left-color: #077cab;
				background-color: #f7f7fa;
			}
			.sidebar__item-icon {
				fill: #a5a4a2;
				height: 24px;
				margin: 0 3px;
				overflow: visible;
				width: 24px;
			}
			.sidebar__item-icon--active {
				fill: #077cab;
			}
			:host([iscollapsed]) .sidebar__menu-item {
				justify-content: center;
				padding: 14px 0;
			}
			:host([iscollapsed]) .sidebar__menu-item-label {
				opacity: 0;
				visibility: hidden;
				width: 0;
				margin: 0;
				transition: opacity 0.1s ease;
			}
		`;
    }
    render() {
        return html `
			<nav class="sidebar">
				<section class="sidebar__header">
					<button class="sidebar__header-button" @click=${this._toggleCollapse}>
						<svg class="sidebar__header-icon">
							<use href="/static/icons.svg#menu" xlink:href="/static/icons.svg#menu" />
						</svg>
					</button>
					<a href="/" class="sidebar__header-logo-link">
						<img
							class="sidebar__header-logo"
							src="https://cms.financialfinesse.com/rafpress/media/2021/03/FF_Logo_SVG.svg"
							alt="Financial Finesse logo"
						/>
					</a>
				</section>

				${this.getSidebarRoutes().map(sidebarRoute => {
            const href = router.urlForPath(sidebarRoute.route);
            const currentPathOnly = (this.currentPath || '').split('?')[0];
            const isHubsPath = currentPathOnly === '/global';
            const isActive = isHubsPath
                ? sidebarRoute.route === '/global' && sidebarRoute.name === 'Global-Dashboard'
                : this.isCurrentLocation(sidebarRoute.route);
            return html `<a
						class="sidebar__menu-item ${isActive ? 'sidebar__menu-item--active' : ''}"
						href="${href}"
						tabindex="-1"
						@click=${(e) => this._onNavClick(e, href)}
					>
						<svg
							class="${isActive
                ? 'sidebar__item-icon sidebar__item-icon--active'
                : 'sidebar__item-icon'}"
						>
							<use
								href="/static/icons.svg#${sidebarRoute.icon}"
								xlink:href="/static/icons.svg#${sidebarRoute.icon}"
							/>
						</svg>
						<span class="sidebar__menu-item-label">${sidebarRoute.name}</span>
					</a>`;
        })}
			</nav>
		`;
    }
};
__decorate([
    state()
], MainSidebar.prototype, "currentPath", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], MainSidebar.prototype, "isCollapsed", void 0);
__decorate([
    subscribe(),
    state()
], MainSidebar.prototype, "blueUser", void 0);
__decorate([
    state()
], MainSidebar.prototype, "authGrants", void 0);
__decorate([
    property()
], MainSidebar.prototype, "parsedToken", void 0);
__decorate([
    property()
], MainSidebar.prototype, "coachEmail", void 0);
MainSidebar = __decorate([
    customElement('main-sidebar')
], MainSidebar);
export { MainSidebar };
//# sourceMappingURL=mainSidebar.js.map